import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

import Layout from "../../components/layout";
import SEO from "../../components/seo";
import StoryCard from "../../components/StoryCard";

export default function Stories() {
  const data = useStaticQuery(graphql`
    query GetAllStories {
      allStoriesJson {
        edges {
          node {
            title
            secondLanguageTitle
            author
            secondLanguageAuthor
            isPremiumStory
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <SEO title={`Stories`} />
      <div
        className="flex flex-col items-center"
        style={{ maxWidth: 900, margin: `0px auto` }}
      >
        <h1>Stories</h1>
        <div className="mt-4">
          <Link className="mx-1 hover:underline" to="russian">
            Russian
          </Link>
          <Link className="mx-1 hover:underline" to="spanish">
            Spanish
          </Link>
        </div>
        <div className="mt-10 flex">
          {data.allStoriesJson.edges.map(({ node }) => {
            return <StoryCard key={node.title} story={node}></StoryCard>;
          })}
        </div>
      </div>
    </Layout>
  );
}
